import { BasicEvent } from "./BasicEvent";
export class ArbetsorderDistriktUpdatedEventMessage extends BasicEvent {
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderDistriktUpdatedEventMessage";
}
